import Vue from 'vue'
import { NativeMessageNotice } from '@/utils/nativeBridge/nativeMessage/index.js'

// 录音实例
let recorderEx = null
// 录音时间
let duration = 0

export const recCreate = () => {}

// 创建实例
export const recInstance = (option = {}) => {
  // if (recorderEx) {
  //   return
  // }
  // const parameter = {
  //   sampleBits: 16, // 采样位数，支持 8 或 16，默认是16
  //   sampleRate: 8000, // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
  //   numChannels: 1, // 声道，支持 1 或 2， 默认是1
  //   ...option
  // }
  // recorderEx = new Recorder(parameter)
  // console.log('recorderEx----')
  // recorderEx.onprogress = function (params) {
  //   // console.log('--------------START---------------')
  //   // console.log('录音时长(秒)', params.duration)
  //   // 记录录制时间
  //   duration = parseInt(params.duration * 1000)
  //   // console.log('录音大小(字节)', params.fileSize);
  //   // console.log('录音音量百分比(%)', params.vol);
  //   // console.log('当前录音的总数据([DataView, DataView...])', params.data);
  //   // console.log('--------------END---------------')
  // }
}

// 开始录音
export const recOpen = cb => {
  // console.log('recOpen-----')
  // h5 没有权限只能通过postmessage调用uniapp api
  const nativeBridge = Vue.prototype.$nativeBridge
  // if (!hasPermission) {
  nativeBridge.sendMessage(
    new NativeMessageNotice({
      type: 'yltxSoundRecording',
      params: {
        action: 'recorderStart' // 获取话筒权限
      }
    })
  )
  // return
  // }
  // if (!recorderEx) {
  //   return
  // }
  // recorderEx
  //   .start()
  //   .then(() => {
  //     // 开始录音
  //     // console.log('录音开始')
  //     recordering = true
  //     typeof cb === 'function' && cb()
  //   })
  //   .catch(err => {
  //     console.warn(err)
  //   })
}

// 结束录音
export const recStop = cb => {
  // console.log('recStop-----')
  const nativeBridge = Vue.prototype.$nativeBridge
  // h5 没有权限只能通过postmessage调用uniapp api
  // if (!hasPermission) {
  nativeBridge.sendMessage(
    new NativeMessageNotice({
      type: 'yltxSoundRecording',
      params: {
        action: 'recorderEnd' // 录音结束
      }
    })
  )
  // 点击过快可能发送一直在录制的情况
  // recordering = false
  typeof cb === 'function' && cb()
  // return
  // }
  // if (!recorderEx) {
  //   return
  // }
  // // 点击过快
  // if (!recordering) {
  //   setTimeout(() => {
  //     // 点击过快可能发送一直在录制的情况
  //     recorderEx && recorderEx.stop()
  //     recordering = false
  //     typeof cb === 'function' && cb()
  //   }, 500)
  //   return
  // }

  // 暂停录音
  // recorderEx.pause()
  // // 结束录制
  // recorderEx.stop()
  // recordering = false
  // // 获取 WAV 数据
  // const wavBlob = recorderEx.getWAVBlob()
  // // blob 数据转成 File 对象
  // const audioFile = new File([wavBlob], 'hello.wav', { type: 'wav' })
  // audioFile.duration = duration // 录音时长
  // duration = 0
  // typeof cb === 'function' && cb(audioFile)
}

// 销毁实例
export const recDestroy = () => {
  // h5 没有权限只能通过postmessage调用uniapp api
  const nativeBridge = Vue.prototype.$nativeBridge
  // if (!hasPermission) {
  nativeBridge.sendMessage(
    new NativeMessageNotice({
      type: 'yltxSoundRecording',
      params: {
        action: 'recorderDestroy' // 获取话筒权限
      }
    })
  )
  return
  // }
  // if (!recorderEx) {
  //   return
  // }
  // // 关闭并销毁录音实例
  // recorderEx.destroy().then(() => {
  //   recorderEx = null
  // })
}
